export default (src) => {
  const image = new Image();
  image.src = src;

  return new Promise((resolve) => {
    image.onload = () => resolve(image.width !== 120 && image.height !== 90);
    image.onerror = () => resolve(false);
  });
};
